import angular from 'angular';

angular
  .module('dashboard', [])

  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider
        .state('envelopes', {
          url: '/envelopes/{tabName}/{specificForm}',
          params: {
            tabName: 'search',
            specificForm: null,
            keepFilter: false
          },
          component: 'envelopeRoute',
          resolve: {
            activeTab: [
              '$transition$',
              function($transition$) {
                return {
                  tabName: $transition$.params().tabName
                };
              }
            ],
            specificForm: [
              '$transition$',
              function($transition$) {
                return $transition$.params().specificForm;
              }
            ],
            keepFilter: [
              '$transition$',
              function($transition$) {
                return $transition$.params().keepFilter;
              }
            ]
          },
          data: {
            authorizedRole: 'USER_BO'
          }
        })
        .state('folders', {
          url: '/folders/{specificForm}',
          params: {
            specificForm: null,
            keepFilter: false
          },
          component: 'folderRoute',
          resolve: {
            specificForm: [
              '$transition$',
              function($transition$) {
                return $transition$.params().specificForm;
              }
            ],
            keepFilter: [
              '$transition$',
              function($transition$) {
                return $transition$.params().keepFilter;
              }
            ]
          },
          data: {
            authorizedRole: 'USER_BO'
          }
        })
        .state('batches', {
          url: '/batches/{tabName}/{specificForm}',
          params: {
            tabName: 'search',
            specificForm: null,
            keepFilter: false
          },
          component: 'batchRoute',
          resolve: {
            activeTab: [
              '$transition$',
              function($transition$) {
                return {
                  tabName: $transition$.params().tabName
                };
              }
            ],
            specificForm: [
              '$transition$',
              function($transition$) {
                return $transition$.params().specificForm;
              }
            ],
            keepFilter: [
              '$transition$',
              function($transition$) {
                return $transition$.params().keepFilter;
              }
            ]
          },
          data: {
            authorizedRole: 'USER_BO'
          }
        })
        .state('messages', {
          url: '/messages',
          params: {
            specificForm: null,
            keepFilter: false
          },
          component: 'messageRoute',
          data: {
            authorizedRole: 'USER_BO'
          },
          resolve: {
            specificForm: [
              '$transition$',
              function($transition$) {
                return $transition$.params().specificForm;
              }
            ],
            keepFilter: [
              '$transition$',
              function($transition$) {
                return $transition$.params().keepFilter;
              }
            ]
          }
        })
        .state('depositors', {
          url: '/depositors/{tabName}',
          params: {
            keepFilter: false
          },
          component: 'depositorRoute',
          data: {
            authorizedRole: 'USER_BO'
          },
          resolve: {
            activeTab: [
              '$transition$',
              function($transition$) {
                return {
                  tabName: $transition$.params().tabName
                };
              }
            ],
            keepFilter: [
              '$transition$',
              function($transition$) {
                return $transition$.params().keepFilter;
              }
            ]
          }
        });
    }
  ]);
